<app-video-background
    class="survey-video"
    [showAnonymous]="false"
    [showLogo]="false"
    source="water"
    background="linear-gradient(180deg, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 1) 100%),
    linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%),
    linear-gradient(0deg, rgba(1, 21, 30, 0.90) 34.64%, rgba(1, 21, 30, 0.00) 76.38%)">
    <div class="redirect">
        <div class="redirect-title">{{ text }}</div>
    </div>
</app-video-background>